import React from "react";
import { useHistory } from "react-router-dom";

import { useQueryString } from "app/context";
import { ProfileLink } from "app/links";
import { Trans } from "app/utils";

import { TimeDiff } from "components/common/Time";
import LazyEditorOutput from "components/editor/LazyEditorOutput";
import UserThumbnail from "components/person/UserThumbnail";

import RecognizedUserList from "./RecognizedUserList";
import RecognizedValueList from "./RecognizedValueList";

const UserDisplay = ({ user, body, creator }) => {
  if (!creator) {
    return (
      <>
        <div className="recognitions__heads">
          <UserThumbnail user={user} />
        </div>
        <LazyEditorOutput output={body} />
      </>
    );
  }

  return (
    <>
      <div className="recognitions__heads">
        <UserThumbnail user={user} />
      </div>
      <ProfileLink user={user} />{" "}
      <Trans>received a recognition:</Trans>{" "}
    </>
  );
};

const UsersDisplay = ({ users }) => (
  <>
    <RecognizedUserList users={users} cap={5} />{" "}
    <Trans>received a recognition:</Trans>{" "}
  </>
);

const RecognitionUserDisplay = ({ users, body, creator }) => {
  if (users.length === 1) {
    return <UserDisplay user={users[0]} body={body} creator={creator} />;
  }
  return <UsersDisplay users={users} />;
};

const RecognitionHeader = ({ recognition }) => {
  const { recognitionType, organizationValues, users, createdAt, body, creator } = recognition;

  const { onToggleQueryStringValue } = useQueryString();
  const history = useHistory();

  const onRecognitionTypeClick = () => {
    if (onToggleQueryStringValue) {
      // Here we're inside a QueryStringProvider, so we can just modify it
      onToggleQueryStringValue("t", recognitionType.id);
    } else {
      // Here we need to go to the recognitions page
      history.push(`/recognitions?t=${recognitionType.id}`);
    }
  };

  return (
    <div className="recognitions__recognition__header clearfix">
      <RecognitionUserDisplay users={users} body={body} creator={creator} />
      {recognitionType && (
        <>
          <button type="button" onClick={onRecognitionTypeClick}>
            {recognitionType.name}
          </button>
          <br />
        </>
      )}
      {!recognitionType && organizationValues.length > 0 && (
        <>
          <RecognizedValueList values={organizationValues} />
          <br />
        </>
      )}
      <span className="recognitions__recognition__date">
        <TimeDiff time={createdAt} format="%B %e at %l:%M %p" />
      </span>
    </div>
  );
};

export default RecognitionHeader;
